import { configureStore } from "@reduxjs/toolkit";
import energyReducer from "./energySlice";
import alertReducer from "./alertSlice";
import knowledgeGraphReducer from "./knowledgeGraphSlice";

export const store = configureStore({
  reducer: {
    energy: energyReducer,
    alerts: alertReducer,
    knowledgeGraph: knowledgeGraphReducer,
    // Add other reducers here as needed
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ["persist/PERSIST"],
        // Ignore these field paths in all actions
        ignoredActionPaths: ["meta.arg", "payload.timestamp"],
        // Ignore these paths in the state
        ignoredPaths: [
          "energy.currentEnergy.timestamp",
          "energy.lastUpdated",
          "alerts.alerts.timestamp",
          "alerts.alerts.expiresAt",
          "knowledgeGraph.nodes.timestamp",
          "knowledgeGraph.relationships.timestamp",
          "knowledgeGraph.patterns.timestamp",
        ],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
